export const mockUsers = [
  { username: "admin", password: "123456", role: "Company" },
  { username: "teacherC", password: "123456", role: "Teacher" },
  { username: "parentA", password: "123456", role: "Parent" },
  { username: "parentB", password: "123456", role: "Parent" },
];

export const mockLessons = [
  {
    id: 1,
    title: "Session 1 - Math",
    teacher: "teacherC",
    grade_id: 1,
    content: [
      { week: 1, slide: 'https://www.canva.com/some-slide-1', summary: 'Basic addition and warmup activities' }
    ],
    quiz: [
      { question: "What is 2 + 3?", options: ["4","5","6","3"], answer: 1 },
      { question: "What is 7 + 0?", options: ["7","0","1","10"], answer: 0 },
      { question: "What is 9 + 6?", options: ["14","15","13","16"], answer: 2 },
      { question: "Which operation result equals 5?", options: ["2+2","1+4","3+3","2+4"], answer: 1 },
      { question: "What is 4 + 4?", options: ["8","9","7","6"], answer: 0 }
    ]
  },
  {
    id: 2,
    title: "Session 2 - Reading",
    teacher: "teacherC",
    grade_id: 1,
    content: [
      { week: 2, slide: 'https://www.canva.com/some-slide-2', summary: 'Reading short stories and comprehension' }
    ],
    quiz: [
      { question: "What is the 'setting' of a story?", options: ["Characters","Time/place","Conflict","Moral"], answer: 1 },
      { question: "Which part introduces characters?", options: ["Middle","End","Beginning","None"], answer: 2 },
      { question: "What helps identify main idea?", options: ["Details","Titles","Pictures","None"], answer: 0 },
      { question: "Plot consists of which sequence?", options: ["End-Middle-Begin","Beginning-Middle-End","Random","Beginning-End-Middle"], answer: 1 },
      { question: "Comprehension improves by?", options: ["Skipping","Rereading","Guessing","Ignoring"], answer: 1 }
    ]
  },
];

export const mockClasses = [
  {
    id: 1,
    name: "Class 1.2",
    teacher: "teacherC",
    students: ["parentA", "parentB"],
    // attendance keyed by date (YYYY-MM-DD) -> list of present student usernames
    attendance: {
      "2025-10-07": ["parentA", "parentB"],
      "2025-10-08": ["parentA"],
      "2025-10-09": ["parentB"]
    }
  },
];

export const mockActivities = [
  {
    classId: 1,
    // activities keyed by date -> student -> items
    byDate: {
      "2025-10-07": {
        parentA: ["Scissors","Glue"],
        parentB: ["Scissors","Paper"]
      },
      "2025-10-08": {
        parentA: ["Color pencils","Paper"],
        parentB: ["Color pencils","Glue"]
      },
      "2025-10-09": {
        parentA: ["Worksheet","Pencil"],
        parentB: ["Worksheet","Eraser"]
      }
    }
  }
];

export const mockNotifications = [
  { id: 1, sender: "parentA", message: "Cảm ơn cô vì bài giảng hôm nay!" },
];

export const mockPosts = [
  {
    id: 1,
    author: 'teacherC',
    title: 'Welcome to Term 1',
    content: 'Hello parents and students! This term we will focus on foundational math and reading skills.',
    createdAt: '2025-10-01',
    likes: ['parentA'],
    comments: [
      { user: 'parentA', text: 'Cảm ơn cô!' }
    ]
  },
  {
    id: 2,
    author: 'admin',
    title: 'School Notice',
    content: 'School will be closed next Friday for teacher training.',
    createdAt: '2025-10-05',
    likes: [],
    comments: []
  }
];
